import { z } from 'zod';

export const GeneralRelationshipDataSchema = z.object({
  notes: z.string(),
});

export type IGeneralRelationshipData = z.infer<
  typeof GeneralRelationshipDataSchema
>;

export function getEmptyGeneralRelationshipData(): IGeneralRelationshipData {
  return {
    notes: '',
  };
}
